import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';
export default {
  saveConfiguration,
  getfactoriesForDropDown,
  getGroupsForDropdown,
  getRoutesByGroupIDFactoryID,
  GetRoutesDropdownforIncentiveConfiguration,
  GetIncentiveConfigurationDetails,
  GetIncentiveConfigurationDetailsbyID,
  getFactoriesByGroupID,
  getAllFactories,
  updateConfiguration,
  deleteConfiguration
};

async function getAllFactories() {
  var factoryArray = [];
  const response = await CommonGet('/api/Factory/GetAllFactories', null);
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getFactoriesByGroupID(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];

  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    if (item[1]["operationEntityTypeID"] == 1 || item[1]["operationEntityTypeID"] == 3) {
      factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
    }
  }
  return factoryArray;
}

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getRoutesByGroupIDFactoryID(groupID, factoryID) {
  var routeArray = [];
  const response = await CommonGet('/api/IncentiveConfiguration/GetRoutesByGroupIDFactoryID', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID))
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function GetRoutesDropdownforIncentiveConfiguration(groupID, factoryID) {
  var routeArray = [];
  const response = await CommonGet('/api/IncentiveConfiguration/GetRoutesDropdownforIncentiveConfiguration', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID))
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function GetIncentiveConfigurationDetails(model) {
  const response = await CommonPost('/api/IncentiveConfiguration/GetIncentiveConfigurationDetails', null, model);
  return response;
}

async function GetIncentiveConfigurationDetailsbyID(incentiveConfigurationID) {
  const response = await CommonGet('/api/IncentiveConfiguration/GetIncentiveConfigurationDetailsbyID', "incentiveConfigurationID=" + parseInt(incentiveConfigurationID));
  return response;
}

async function saveConfiguration(saveModel) {
  const formattedModel = {
    groupID: parseInt(saveModel.groupID),
    factoryID: parseInt(saveModel.factoryID),
    routes: saveModel.routes.map((route) => ({
      routeID: parseInt(route.routeID),
      cropWeight: parseFloat(parseFloat(route.cropWeight).toFixed(2).toString()),
      amountPerKilo: parseFloat(parseFloat(route.amountPerKilo).toFixed(2).toString()),
    })),
    createdBy: tokenDecoder.getUserIDFromToken(),
  };

  const response = await CommonPost('/api/IncentiveConfiguration/SaveIncentiveConfiguration', null, formattedModel);
  return response;
}

async function updateConfiguration(updateModel) {
  const model = Array.isArray(updateModel) ? updateModel[0] : updateModel;

  const formattedModel = {
    incentiveConfigurationID: model.incentiveConfigurationID,
    groupID: parseInt(model.groupID),
    factoryID: parseInt(model.factoryID),
    routeID: parseInt(model.routeID),
    cropWeight: parseFloat(parseFloat(model.cropWeight).toFixed(2).toString()),
    amountPerKilo: parseFloat(parseFloat(model.amountPerKilo).toFixed(2).toString()),
    createdBy: tokenDecoder.getUserIDFromToken(),
  };
  const response = await CommonPost('/api/IncentiveConfiguration/UpdateIncentiveConfiguration', null, formattedModel);
  return response;
}

async function deleteConfiguration(incentiveConfigurationID) {
  const response = await CommonGet('/api/IncentiveConfiguration/DeleteIncentiveConfiguration',`incentiveConfigurationID=${incentiveConfigurationID}&deletedBy=${tokenDecoder.getUserIDFromToken()}`
  );
  return response;
}